import React from "react"
import PropTypes from "prop-types"
import { StyledDateField } from "./styles"
import DateField from "../../forms/date-field"
import moment from "moment"

const DefaultDateField = ({ handleInputChange, ...rest }) => {
  const { name, value, min, max, placeholder, homepage, simpleForm } = rest
  const onChange = (value) => {
    if (handleInputChange !== undefined) {
      const date = new Date(value)
      handleInputChange(name, date)
    }
  }
  const selected = value ? moment(value).format("YYYY-MM-DD") : ""
  const minDate = min ? moment(min).format("YYYY-MM-DD") : ""
  const maxDate = max ? moment(max).format("YYYY-MM-DD") : ""

  const isDateSupported = () => {
    let i = document.createElement("input")
    i.setAttribute("type", "date")
    return i.type !== "text"
  }

  return isDateSupported() ? (
    <StyledDateField
      type="date"
      defaultValue={selected}
      placeholder={placeholder}
      min={minDate}
      max={maxDate}
      onInput={(date) => onChange(date.target.value)}
      homepage={homepage}
      simpleForm={simpleForm}
    />
  ) : (
    <DateField handleInputChange={handleInputChange} {...rest} />
  )
}

DefaultDateField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string
}

DefaultDateField.defaultProps = {
  handleInputChange: undefined,
  placeholder: ""
}

export default DefaultDateField
